export default __webpack_public_path__ + "static/media/position.77df16e2.svg";